import { skipToken } from "@reduxjs/toolkit/query";
import type {
  MetadataFieldId,
  SignalId,
} from "@repo/app-types/entities/signal";
import {
  getSimpleSelectOptionLabel,
  type SimpleSelectOption,
} from "@repo/ui/Select/simpleSelect";
import { useMemo } from "react";
import { useGetSignalQuery } from "../api/entities/signal.js";

export function useSignalMetadataFieldSelectOptions(
  signalId: SignalId | undefined,
): SimpleSelectOption<MetadataFieldId>[] {
  const { currentData: signal } = useGetSignalQuery(signalId ?? skipToken);

  const options = useMemo(() => {
    // TODO: Better loading state.
    if (!signal) {
      return [];
    }

    const options: SimpleSelectOption<MetadataFieldId>[] =
      signal.metadata_schema.fields.map((metadataField) => ({
        value: metadataField.id,
        label: metadataField.key,
      }));

    return options;
  }, [signal]);

  return options;
}

export function useSignalMetadataFieldSelectLabel(
  options: SimpleSelectOption<MetadataFieldId>[],
  selectedMetadataFieldId: MetadataFieldId | undefined,
) {
  return useMemo(() => {
    if (!options || !selectedMetadataFieldId) {
      return undefined;
    }

    return (
      getSimpleSelectOptionLabel(options, selectedMetadataFieldId) ?? "Unknown"
    );
  }, [options, selectedMetadataFieldId]);
}
